import {notNil} from '@megaphonenpm/mputils/src/utils.js';
import {RangeIndicator} from "./RangeIndicator.js";
import {awaitRender, onVisible} from '@megaphonenpm/mputils/src/DOM.js';

export class SurveyBarComponent extends RangeIndicator {
  constructor (themeID) {
    super(themeID, 'bar');
  }

  build () {
    super.build();
    this.barFG = this.view.querySelector('.barFG');
    this.barBG = this.view.querySelector('.barBG');
  }

  // TODO: Replace this manual approach with a generic measuring strategy that can determine
  //  width and height of elements even when they are not currently in the DOM.
  // TODO: Use setSize() method instead of direct CSS-style assignment.
  applyExplicitHeight () {
    // Assign the .bar element an explicit height so that it can be aligned within a parent container.
    // The height assigned is the taller of the .barFG and .barBG elements. Retrieve height using
    // getComputedStyle() because getComputedStyle() returns the theme's intended height (i.e., the
    // height as specified in the theme's CSS rules).
    let computedBarBGHeight = parseInt(getComputedStyle(this.view.querySelector('.barBG')).height);
    let computedBarFGHeight = parseInt(getComputedStyle(this.view.querySelector('.barFG')).height);
    this.view.style.height = Math.max(computedBarBGHeight, computedBarFGHeight) + 'px';
  }

  disableAnimation () {
    this.barFG.classList.remove('transitionWidth');
    if (notNil(this.valueLabel)) {
      this.valueLabel.view.classList.remove('transitionLeft');
    }
  }

  enableAnimation () {
    this.barFG.classList.add('transitionWidth');
    if (notNil(this.valueLabel)) {
      this.valueLabel.view.classList.add('transitionLeft');
    }
  }

  setValue (percent) {
    super.setValue(percent);
    this.barFG.style.width = percent + '%';
    if (this.valueLabel) {
      this.valueLabel.view.style.left = `${this.width * (percent/100)}px`;
    }
  }

  setValueLabel (valueLabel) {
    super.setValueLabel(valueLabel);

    // Position the indicator label as soon as its dimensions become available
    if (this.valueLabel) {
      onVisible(this.view, () => {
        awaitRender().then(() => {
          let valueLabelSize = this.valueLabel.getSize();
          this.valueLabel.view.style.marginLeft = `-${valueLabelSize.width/2}px`;
          this.valueLabel.view.style.marginTop = `${-valueLabelSize.height - this.pointerGap}px`;
        });
      });
    }
  }

  setPointerGap (pointerGap) {
    this.pointerGap = pointerGap;
  }

  updateValueLabel (percent) {
    super.updateValueLabel(percent);

    percent = percent/100;
    if (this.valueLabel) {
      // Set value label position
      this.valueLabel.style.left = `${this.width * (percent)}px`;
    }
  }

  setSize (width, height) {
    super.setSize(width, height);
    this.barFG.style.height = `${height}px`;
    this.barBG.style.height = `${height}px`;
  }
}
